import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import translate from '@i18n'
import SvgIcon from '@components/SvgIcon'

interface Props {
  isPinned: boolean
}

const Wrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 45px 45px 0;
  border-color: transparent ${({ theme }) => theme.colors.brandColors.brand_55}
    transparent transparent;
  text-align: right;
`

const IconContainer = styled.div`
  position: relative;
  padding: 6px;
  width: 45px;
  height: 45px;
  box-sizing: border-box;
  cursor: default;
`

const PinnedLabel: FunctionComponent<Props> = ({ isPinned }) => {
  const theme = useContext(ThemeContext)
  return isPinned ? (
    <Wrapper>
      <IconContainer title={translate('scribble.topPost')}>
        <SvgIcon
          iconName="newsticker-star-big"
          size={13}
          color={theme.colors.white}
        />
      </IconContainer>
    </Wrapper>
  ) : null
}

export default PinnedLabel
